module.exports = __webpack_public_path__ + "img/wechat-wordcloud.56b12d33.jpg";